// Generated by generate/render-markdown.ts. Do not edit.
export interface ExampleEntry {
  path: string; domain: string; title: string; description: string;
  participants: number; results: number; rankings: number; measures: string[];
}
export const examples: ExampleEntry[] = [
  {
    "path": "agricultural-show/wrenbury-vale-2026.openresult.json",
    "domain": "agricultural-show",
    "title": "Wrenbury Vale County Show 2026 — Cattle",
    "description": "Seven judged classes across three breeds, three breed championships and the supreme cattle championship. Nothing here is measured: there is no time, no weight and no score. Each class is an order one judge decided by eye, so every ranking declares ties: \"resolved\" with an empty sortBy (§8.2.1, §8.3.5) and the order is carried entirely by the published positions in ranks. The judge's spoken reasons are recorded in notes, which §7.4.1 says nothing will parse. Prize money is recorded as a measure of kind money whose betterWhen is none: it follows from the placing and never decides it. Version 2, amended: one yearling heifer was disqualified after the ring on a registration irregularity and the animals behind her have moved up.",
    "participants": 37,
    "results": 50,
    "rankings": 11,
    "measures": []
  },
  {
    "path": "ai-benchmark/reasoning-eval-2026.openresult.json",
    "domain": "ai-benchmark",
    "title": "Open Reasoning Eval — May 2026",
    "description": "Four task suites scored as accuracy, plus an aggregate. Participants are software models; one entry did not complete the long-context suite, which is recorded as an absent measure rather than a zero.",
    "participants": 5,
    "results": 5,
    "rankings": 4,
    "measures": [
      "Aggregate score",
      "Mathematics",
      "Code generation",
      "Long context",
      "Median latency",
      "Cost per run"
    ]
  },
  {
    "path": "cpu-benchmark/render-suite-2026.openresult.json",
    "domain": "cpu-benchmark",
    "title": "Render Suite 2026 Q2 — desktop processors",
    "description": "Multi-threaded render benchmark. Participants are machines rather than people, which the format handles without a special case.",
    "participants": 6,
    "results": 6,
    "rankings": 2,
    "measures": [
      "Render time",
      "Throughput",
      "Package power",
      "Efficiency",
      "Cores"
    ]
  },
  {
    "path": "edge-cases/announced-no-results.openresult.json",
    "domain": "edge-cases",
    "title": "Edge case — announced event, no results yet",
    "description": "An empty results array is valid. The entry list, the measures and the ranking rule are all published in advance; only the results are missing. A consumer must render this without error.",
    "participants": 2,
    "results": 0,
    "rankings": 1,
    "measures": [
      "Time"
    ]
  },
  {
    "path": "edge-cases/bye-in-an-odd-field.openresult.json",
    "domain": "edge-cases",
    "title": "Edge case — a bye in an odd field",
    "description": "Seven competitors over three rounds. With an odd field one player sits out each round and scores unopposed: rankable, unlike every other non-finished status. Compare with the withdrawal, which holds points and is still excluded.",
    "participants": 7,
    "results": 7,
    "rankings": 1,
    "measures": [
      "Points",
      "Tie-break"
    ]
  },
  {
    "path": "edge-cases/extensions-and-unknown-values.openresult.json",
    "domain": "edge-cases",
    "title": "Edge case — extensions and unknown enumeration values",
    "description": "Carries x- extensions at document, entity and result level, plus enumeration values a 1.0 consumer does not know. All of it must be ignored without error, preserved on rewrite, and must not affect the derived ranking.",
    "participants": 3,
    "results": 3,
    "rankings": 1,
    "measures": [
      "Time"
    ]
  },
  {
    "path": "edge-cases/lifecycle-amended.openresult.json",
    "domain": "edge-cases",
    "title": "Edge case — amended results",
    "description": "Supersedes lifecycle-provisional.openresult.json: same id, higher version. Competitor B was disqualified after the protest was upheld, which changes the standings without rewriting history — both documents remain valid.",
    "participants": 3,
    "results": 3,
    "rankings": 1,
    "measures": [
      "Time"
    ]
  },
  {
    "path": "edge-cases/lifecycle-provisional.openresult.json",
    "domain": "edge-cases",
    "title": "Edge case — provisional results",
    "description": "Published while a protest is open. Superseded by lifecycle-amended.openresult.json, which carries the same id and a higher version. Between two documents sharing an id, the higher version wins.",
    "participants": 3,
    "results": 3,
    "rankings": 1,
    "measures": [
      "Time"
    ]
  },
  {
    "path": "edge-cases/missing-values-and-statuses.openresult.json",
    "domain": "edge-cases",
    "title": "Edge case — absent measures and non-rankable statuses",
    "description": "Competitor B scored zero, which is a value. Competitor C has no score at all, which is not. Competitors D through G carry each of the non-rankable statuses: they appear in the output without a rank, never omitted.",
    "participants": 7,
    "results": 7,
    "rankings": 1,
    "measures": [
      "Score",
      "Attempts"
    ]
  },
  {
    "path": "edge-cases/no-ranking-declared.openresult.json",
    "domain": "edge-cases",
    "title": "Edge case — no ranking declared",
    "description": "The document declares no rankings and carries no rank. A consumer must still order it, using the implicit ranking: the first measure whose betterWhen is not none, standard tie handling, non-rankable statuses excluded. The average heart rate is measured and never ranked, so the implicit ranking skips it and settles on the time. The bib is an attribute, not a measure: it is allocated rather than observed (spec §5.3.5).",
    "participants": 3,
    "results": 3,
    "rankings": 0,
    "measures": [
      "Average heart rate",
      "Time"
    ]
  },
  {
    "path": "edge-cases/ties-dense.openresult.json",
    "domain": "edge-cases",
    "title": "Edge case — ties under dense numbering",
    "description": "Identical data to ties-standard.openresult.json. Under ties=dense no rank is skipped: 1, 2, 2, 3. The same results produce different ranks because the declared rule differs, which is why the rule belongs in the document.",
    "participants": 4,
    "results": 4,
    "rankings": 1,
    "measures": [
      "Points"
    ]
  },
  {
    "path": "edge-cases/ties-standard.openresult.json",
    "domain": "edge-cases",
    "title": "Edge case — ties under standard numbering",
    "description": "Two competitors level on the deciding measure. Under ties=standard the shared rank consumes the following one: 1, 2, 2, 4. Compare with ties-dense.openresult.json, which holds identical data.",
    "participants": 4,
    "results": 4,
    "rankings": 1,
    "measures": [
      "Points"
    ]
  },
  {
    "path": "esport/spring-split-playoffs.openresult.json",
    "domain": "esport",
    "title": "Arena League — Spring Split Playoffs",
    "description": "Group stage followed by a bracket. Teams are participants composed of participants, so a roster is expressed without leaving the model.",
    "participants": 12,
    "results": 12,
    "rankings": 2,
    "measures": [
      "Series won",
      "Maps won",
      "Map difference",
      "Round win rate"
    ]
  },
  {
    "path": "football/matchday-14.openresult.json",
    "domain": "football",
    "title": "Riverside League — Matchday 14",
    "description": "Four fixtures and the resulting table. Each match is one event holding two results, one per team — a head-to-head is not a special case in this model.",
    "participants": 8,
    "results": 16,
    "rankings": 1,
    "measures": [
      "Goals",
      "Points",
      "Goal difference",
      "Goals for",
      "Played"
    ]
  },
  {
    "path": "hackathon/civic-data-jam.openresult.json",
    "domain": "hackathon",
    "title": "Civic Data Jam 2026",
    "description": "Jury scoring across four criteria plus a weighted total. The weighting rule is described for the reader but not encoded: the format carries the resulting figures, never a formula to evaluate.",
    "participants": 6,
    "results": 6,
    "rankings": 3,
    "measures": [
      "Weighted total",
      "Impact",
      "Technical execution",
      "Originality",
      "Presentation",
      "Team size"
    ]
  },
  {
    "path": "karting/sprint-cup-final.openresult.json",
    "domain": "karting",
    "title": "Sprint Cup — Round 5",
    "description": "Timed qualifying followed by the final. Time penalties are applied to the recorded time by the producer; the format carries the resulting figure, not the rule that produced it.",
    "participants": 6,
    "results": 12,
    "rankings": 2,
    "measures": [
      "Best lap",
      "Final time",
      "Penalty",
      "Laps"
    ]
  },
  {
    "path": "motocross/regional-round-3.openresult.json",
    "domain": "motocross",
    "title": "Regional Motocross Championship — Round 3",
    "description": "Two races per class, points awarded per race, overall standings from the points total. Race 2 result amended after the stewards' decision on rider 41.",
    "participants": 8,
    "results": 24,
    "rankings": 4,
    "measures": [
      "Points",
      "Race time",
      "Laps",
      "Best lap",
      "Points in the final race"
    ]
  },
  {
    "path": "motorsport/coastal-endurance-4h.openresult.json",
    "domain": "motorsport",
    "title": "Coastal Endurance — 4 Hours",
    "description": "Endurance race classified on laps completed, then on elapsed time. One car finished outside the time limit, a status distinct from retiring.",
    "participants": 6,
    "results": 6,
    "rankings": 4,
    "measures": [
      "Laps completed",
      "Total time",
      "Best lap",
      "Pit stops",
      "Time penalty"
    ]
  },
  {
    "path": "photo-contest/wildlife-open-2026.openresult.json",
    "domain": "photo-contest",
    "title": "Wildlife Open 2026",
    "description": "Public vote combined with a jury score. Two entries finish level and share second place; the images are attached as assets, which never affect interpretation.",
    "participants": 5,
    "results": 5,
    "rankings": 3,
    "measures": [
      "Final score",
      "Jury score",
      "Public votes"
    ]
  },
  {
    "path": "running/crest-trail-21k.openresult.json",
    "domain": "running",
    "title": "Crest Trail 2026 — 21 km",
    "description": "Mountain trail race, 21.4 km with 1,050 m of elevation gain. Scratch and age-category standings.",
    "participants": 10,
    "results": 10,
    "rankings": 3,
    "measures": [
      "Finish time",
      "Average pace"
    ]
  },
  {
    "path": "sales-ranking/q1-partner-league.openresult.json",
    "domain": "sales-ranking",
    "title": "Partner League — Q1 2026",
    "description": "Quarterly partner performance. Participants are organisations, the deciding measure is monetary, and the tie-break is the retention rate.",
    "participants": 6,
    "results": 6,
    "rankings": 3,
    "measures": [
      "Net revenue",
      "Year-on-year growth",
      "Customer retention",
      "Closed deals",
      "Average deal size"
    ]
  },
  {
    "path": "swimming/vallonne-meet-100free.openresult.json",
    "domain": "swimming",
    "title": "Vallonne International Meet 2026 — 100 m freestyle, women",
    "description": "Three qualifying heats, a swim-off for the last place in the final, and the final itself. The qualifying classification lists its three heats in scope.event rather than republishing their times (spec §8.1.5), so every swim appears exactly once. The swim-off is settled outside the document — no measure holds its outcome — so the classification declares ties: \"resolved\" and the published positions break the tie (§8.3.4).",
    "participants": 12,
    "results": 22,
    "rankings": 6,
    "measures": [
      "Time",
      "50 m split",
      "Reaction"
    ]
  },
  {
    "path": "wine-competition/vallonne-whites-2026.openresult.json",
    "domain": "wine-competition",
    "title": "Concours des Vins de Vallonne 2026 — white wines",
    "description": "Blind tasting by a panel of six. Each criterion is marked against its own maximum, and those maxima are declared (§5.1.8) so a reader can tell 27 out of 30 from 27 out of 100 — and so a consumer can render 36/40 rather than 36 pt. Medals follow thresholds under a quota, not positions, which is why they are attributes and not a ranking.",
    "participants": 8,
    "results": 8,
    "rankings": 3,
    "measures": [
      "Appearance",
      "Nose",
      "Palate",
      "Harmony",
      "Total"
    ]
  }
];
